//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { UploadProductImageResponse } from '@apis/campaign-requests/sampling/products/samplingProductsApiModel';
import { makeParams } from '@utils/makeParams';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const SAMPLING_DEFAULT_ENDPOINT = '/api/v1/clients';

const samplingFetch = (
  endpoint: string,
  init?: RequestInit,
  useFetchHeader?: boolean,
): Promise<ISerializedResponse> =>
  serializedGatewayFetch(
    'sampling_gateway',
    `${SAMPLING_DEFAULT_ENDPOINT}${endpoint}`,
    init,
    useFetchHeader,
  );

export const uploadSamplingProductImage = async (
  req: {
    file: File;
    productId: string;
    variationName?: string;
  },
  init?: RequestInit,
): Promise<UploadProductImageResponse> => {
  const formData = new FormData();
  formData.append('file', req.file, req.file.name);

  const params = makeParams({
    variationName: req.variationName,
  });

  const res = await samplingFetch(
    `/products/${req.productId}/image/upload${params ? `?${params}` : ''}`,
    {
      ...init,
      method: 'POST',
      body: formData,
    },
    true,
  );

  const { data } = await res.json<{ data: UploadProductImageResponse }>();
  return data;
};
